<app-layout-header>

  <ng-content></ng-content>

</app-layout-header>
<app-layout-footer *ngIf="propertyUrlSegment !== '/account' && propertyUrlSegment !== '/property' && propertyUrlSegment !== '/management'  && propertyUrlSegment !== '/wallet'"></app-layout-footer>

